import { Injectable, ErrorHandler } from '@angular/core';
import { Logtype } from '../../enums/log/logtype.enum';
import { environment } from '../../../environments/environment';
import * as Sentry from '@sentry/browser';
import { LogModel } from '../../models/log.model';

// Sentry.init({
//   dsn: environment.sentry.dsn,
//   environment: environment.environment,
//   release: environment.version,
//   beforeSend: (event, hint) => {
//     if (environment.sentry.logs) {
//       console.error(hint.originalException || hint.syntheticException);
//     }
//     if (environment.sentry.enable) {
//       return event;
//     } else {
//       return null; // this drops the event and nothing will be sent to sentry
//     }
//   }
// });
// console.log(`Sentry initilized ${environment.environment} - ${environment.version}`);

@Injectable({
  providedIn: 'root'
})
export class LogService implements ErrorHandler {
  constructor() {}
  handleError(error) {
    // const eventId = Sentry.captureException(error.message || error.error || error);
    // if (environment.sentry.reportDialog) {
    //   Sentry.showReportDialog({ eventId });
    // }
  }
  /**
   *
   * @param type log type
   * @param message object message with the log detail
   * @param classOrigin class where the log is called (this.constructor.toString().match(/\w+/g)[1])
   * @param methodOrigin method where the log is called
   */
  async createLog(type: Logtype, message: Object, classOrigin: string, methodOrigin: string) {
    // if (environment.sentry.logs) {
    //   const logObj: LogModel = {
    //     typeLog: type,
    //     class: classOrigin,
    //     method: methodOrigin,
    //     messageLog: message
    //   };
    //   if (type === Logtype.ERROR) {
    //     console.error(logObj);
    //   } else if (type === Logtype.INFO) {
    //     console.info(logObj);
    //   }
    // }
  }
}
